import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    orgId = '',
    depId = '',
    items = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpi.importProjKpis, {
        orgId,
        depId,
        items,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
